import { lazy } from 'react';

export const ListEquipmentPageLazy = lazy(() => import('./ListEquipmentPage'));
